// extracted by mini-css-extract-plugin
module.exports = {"container":"_b9","logo":"_ca","mainPanel":"_cb","noActions":"_cc","noOneLeftAction":"_cd","noRightAction":"_ce","onlyOneLeftAction":"_cf"};